import React, { useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { Collapse, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import Scrollbar from "smooth-scrollbar";
import dashboardBlue from "../../icons/DashboardBlue.svg";
import reportBlue from "../../icons/ReportBlue.svg";
import createSolnBlue from "../../icons/CreateSolnBlue.svg";
import masterBlue from "../../icons/MasterBlue.svg";
import allSolnRecordsBlue from "../../icons/AllSolnRecordsBlue.svg";
import solnPendingBlue from "../../icons/SolnPendingBlue.svg";
import {
  APPROVAL_HIEARCHY_MASTER,
  COMPRESSOR_MASTER,
  COUNTRY_MASTER,
  CUSTOMER_MASTER,
  DEALER_MASTER,
  LOCATION_MASTER,
  MAIL_REMINDER,
  PRODUCT_MASTER,
  ROLE_AUTHORIZATION_MASTER,
  UNIT_CONVERSION_MASTER,
  USER_MASTER,
  CREATE_NEW_SOLUTION,
  DASHBOARD,
  REPORTS,
  ALL_SOLUTION_RECORDS,
  PENDING_FOR_APPROVAL,
} from "../../utils/constant";
import AEM_Logo from "../../icons/GCEM_Logo.svg";
import Toggler from "../../icons/Toggler.svg";
import HeadLogo from "../../icons/HeadLogo.svg";
import { store } from "../../redux/store";
import { useDispatch } from "react-redux";
import { getInitials } from "../../functions/functions";
import { useLocation, useHistory } from "react-router-dom";
import { setLogout, setSideBar } from "../../redux/redux/global/action";
import DownArrow from "../../icons/DownArrow.svg";
import LogOut from "../../icons/LogOut.svg";
import LogOutWhite from "../../icons/Logoutwhite.svg";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import useLogout from "../../hooks/useLogout";


const SideBarComp = ({
  menuName,
  userName,
  userEmail,
  setMenuName,
  showSidebar,
  setShowSidebar,
}) => {
  const [dashboardMenu, setDashboardMenu] = useState(false);
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const access = store.getState().global?.userDetails?.accessData || [];
  const userType = store.getState().global?.userDetails?.um_type || ""
  const userRole = store.getState().global?.userDetails?.um_role || ""
  const location = useLocation();
  const initials = getInitials(userName);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleLogout = useLogout();

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
    setMenu(false);
    setDashboardMenu(false)
    dispatch(setSideBar(!showSidebar));
  };

  const handleNavClick = () => {
    setShowSidebar(false);
    setMenu(false);
    setDashboardMenu(false)
  };



  const NavItem = ({ access: requiredAccess, to, eventKey, icon, title, onClick }) => {
    if (!access.includes(requiredAccess)) return null;
    return (
      <Nav.Item as="li">
        <Nav.Link
          as={Link}
          to={to}
          eventKey={eventKey}
          bsPrefix="nav-list-item"
          className={location.pathname === to ? "active1" : "inactive"}
          onClick={onClick}
          title={title}
        >
          <div style={{ position: "relative" }}>
            <img src={icon} alt={title} className="img1" />
          </div>
          <span className="menu-name">{title}</span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  const SubNavItem = ({ access: requiredAccess, to, eventKey, title }) => {
    if (!access.includes(requiredAccess)) return null;
    return (
      <Nav.Item as="li">
        <Nav.Link
          eventKey={eventKey}
          as={Link}
          to={to}
          bsPrefix="sub-menu-item"
          className={location.pathname === to ? "active1" : "inactive"}
        >
          {title}
        </Nav.Link>
      </Nav.Item>
    );
  };

  const DashboardSubNavItem = ({ access: requiredAccess, to, eventKey, title, condition }) => {
    if (!access.includes(requiredAccess) || !condition) return null;
    return (
      <Nav.Item as="li">
        <Nav.Link
          eventKey={eventKey}
          as={Link}
          to={to}
          bsPrefix="sub-menu-item"
          className={location.pathname === to ? "active1" : "inactive"}
        >
          {title}
        </Nav.Link>
      </Nav.Item>
    );
  };

  useEffect(() => {
    const Scroll = Scrollbar.init(document.querySelector("#Sidebar-Body"));
    Scroll.track.xAxis.element.remove();
  }, []);

  return (
    <>
      <ConfirmAlertModal
        handleYes={handleLogout}
        formName={"Logout"}
        show={show}
        handleClose={() => setShow(false)}
      />
      <div
        id="Sidebar"
        className={showSidebar ? "side-bar open" : "side-bar closed"}
      >
        <div className="sidebar-head">
          <img src={AEM_Logo} alt="AEM Logo" className="head-logo ms-2" />
          {showSidebar && (
            <img src={Toggler} alt="Toggler" onClick={toggleSidebar} className="hamburger" />
          )}
          {!showSidebar && (
            <>
              <img
                src={Toggler}
                alt="Toggler"
                className="d-md-none d-lg-none"
                onClick={toggleSidebar}
              />
              <img
                src={HeadLogo}
                alt="HeadLogo"
                className="head-toggle d-none d-md-block d-lg-block"
                onClick={toggleSidebar}
              />
            </>
          )}
        </div>
        {showSidebar && (
          <div className="sidebar-head-2 d-md-none d-lg-none">
            <div className="user-section">
              <div className="user-logo">
                <span>{initials}</span>
              </div>
              <div className="user-info">
                <span className="user-name">{userName}</span>
                <span className="user-email">{userEmail}</span>
              </div>
            </div>
            <div className="headerMenu-item" onClick={() => setShow(true)}>
              <img src={LogOut} alt="LogOut" />
            </div>
          </div>
        )}
        {/* <div className="sidebar-body d-none d-md-block d-lg-block" id="Sidebar-Body"> */}
        <div className="sidebar-body" id="Sidebar-Body">
          <span className="menu">Menu</span>
          <Nav
            as="ul"
            bsPrefix="nav-list"
            // defaultActiveKey={"Dashboard"}
            onSelect={(selectedKey) => setMenuName(selectedKey)}
          >
      
            

            <NavItem access={DASHBOARD} to="/dashboard" eventKey="Dashboard" icon={dashboardBlue} title="Dashboard" />
            <NavItem access={REPORTS} to="/report" eventKey="Reports" icon={reportBlue} title="Reports" />
            <NavItem
              access={CREATE_NEW_SOLUTION}
              to="/newenquiry"
              eventKey="Create New Solution"
              icon={createSolnBlue}
              title="Create New Solution"
              onClick={() => {
                if (window.location.href.split("/").pop() === "newenquiry") {
                  window.location.reload();
                }
              }}
            />
            <NavItem access={ALL_SOLUTION_RECORDS} to="/allsolution" eventKey="All Records" icon={allSolnRecordsBlue} title="All Solution Records" />
            <NavItem access={PENDING_FOR_APPROVAL} to="/allsolutionapproval" eventKey="All Soultions for Approval" icon={solnPendingBlue} title="Solutions Pending for Approval" />

            <hr style={{ margin: "8px" }} />
            {[USER_MASTER, COMPRESSOR_MASTER, DEALER_MASTER, PRODUCT_MASTER, ROLE_AUTHORIZATION_MASTER, UNIT_CONVERSION_MASTER, LOCATION_MASTER, CUSTOMER_MASTER, COUNTRY_MASTER, MAIL_REMINDER].some(permit => access.includes(permit)) && (
              <Nav.Item as="li" onClick={() => { setShowSidebar(true); setMenu(!menu); }}>
                <Nav.Link eventKey="Master Data" bsPrefix="nav-list-item" title="Master Data">
                  <div style={{ position: "relative" }}>
                    <img src={masterBlue} alt="master" className="img1" />
                  </div>
                  <span className="menu-name">Master Data <BsChevronDown size={15} /></span>
                </Nav.Link>
              </Nav.Item>
            )}
            <Collapse in={menu}>
              <div>
                <ul className="nav-sub-menu">
                  <SubNavItem access={USER_MASTER} to="/user" eventKey="User Master" title="User Master" />
                  <SubNavItem access={ROLE_AUTHORIZATION_MASTER} to="/role" eventKey="Role & Authorization Master" title="Role & Authorization Master" />
                  <SubNavItem access={DEALER_MASTER} to="/dealer" eventKey="Dealer Master" title="Dealer Master" />
                  <SubNavItem access={LOCATION_MASTER} to="/loc" eventKey="Location Master" title="Location Master" />
                  <SubNavItem access={CUSTOMER_MASTER} to="/cust" eventKey="Customer Master" title="Customer Master" />
                  <SubNavItem access={PRODUCT_MASTER} to="/product" eventKey="Product Master" title="Product Master" />
                  
                  <SubNavItem access={UNIT_CONVERSION_MASTER} to="/unit" eventKey="Unit Conversion Master" title="Unit Conversion Master" />
                  <SubNavItem access={COMPRESSOR_MASTER} to="/compressor" eventKey="Compressor Master" title="Compressor Master" />
                  <SubNavItem access={COUNTRY_MASTER} to="/currency" eventKey="Currency Master" title="Currency Master" />
                  <SubNavItem access={MAIL_REMINDER} to="/mail" eventKey="Mail Reminder" title="Mail Reminder" />
                </ul>
              </div>
            </Collapse>
            <Nav.Item as="li" onClick={() => setShow(true)}>
              <Nav.Link bsPrefix="nav-list-item" title="Logout">
                <div style={{ position: "relative" }}>
                  <img src={LogOut} alt="LogOut" className="img1" />
                </div>
                <span className="menu-name">Logout</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </div>
    </>
  );
};

export default SideBarComp;
